import api, { apiFormatError } from "@/lib/api";
import { toast } from "sonner";

export const STATUSES = ["new", "reviewed", "contacted", "closed"];
export const totalDoors = (items) => (items || []).reduce((sum, item) => sum + (Number(item.quantity) || 1), 0);
export const fmtUsd = (value) => Number(value).toLocaleString("en-US", { style: "currency", currency: "USD" });
export const itemTotal = (item) => (Number(item.quantity) || 1) * (Number(item.unit_price) || 0) * (1 - (Number(item.discount_pct) || 0) / 100);
export const reportError = (error, action) => {
  console.error(`${action} failed`, error.response?.status);
  toast.error(`${action}: ${apiFormatError(error.response?.data?.detail)}`);
};
export async function downloadFile(path, name) {
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const link = document.createElement("a"); link.href = url; link.download = name;
    document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (error) { reportError(error, "Download"); }
}